import React from 'react';
import { Routes, Route } from 'react-router-dom';

import './App.css';
import HashRedirect from './components/HashRedirect';
import ErrorBoundary from './components/ErrorBoundary';
import PostList from './pages/PostList';
import PostDetailPage from './pages/PostDetailPage';
import { ENTITY } from './utils/constants';

const App = () => {
  return (
    <ErrorBoundary>
      <a href="#main-content" className="skip-link">
        Saltar al contenido principal
      </a>
      <HashRedirect />
      <Routes>
        <Route path="/" element={<PostList />} />
        <Route path={ENTITY.routes.detail} element={<PostDetailPage />} />
      </Routes>
    </ErrorBoundary>
  );
};

export default App;
